import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("Travea crash:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        fontFamily: "'DM Sans',sans-serif",
        background: "#0F0E0C",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        color: "#E8E2D8",
      }}>
        <div style={{
          width: 38, height: 38, background: "#C9A96E",
          borderRadius: 10, display: "flex", alignItems: "center",
          justifyContent: "center", fontSize: 20, marginBottom: 24,
        }}>⬡</div>
        <h2 style={{
          fontFamily: "'DM Serif Display',serif",
          fontSize: 22, fontWeight: 400,
          marginBottom: 12, textAlign: "center",
        }}>
          Une erreur est survenue
        </h2>
        <p style={{
          fontSize: 13, color: "#7A7468",
          marginBottom: 28, textAlign: "center", maxWidth: 320,
        }}>
          L'application a rencontré un problème inattendu. Vos données sont sauvegardées.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            background: "#C9A96E", color: "#0F0E0C",
            border: "none", borderRadius: 10,
            padding: "12px 28px", fontSize: 14,
            fontWeight: 600, cursor: "pointer",
          }}>
          Recharger l'application →
        </button>
      </div>
    );
  }
}
